<div *ngIf="rating && nStars" class="star-container">
  <img *ngFor="let filledStar of filledStarsArray" src="./../../../../assets/images/icons/star-filled.svg" alt="Filled rating Star" />
  <img *ngFor="let unfilledStar of unfiledStarsArray" src="./../../../../assets/images/icons/star-unfilled.svg" alt="Unfilled rating Star" />
</div>

<div *ngIf="!rating" class="star-container">
  <img src="./../../../../assets/images/icons/star-unfilled.svg" alt="Filled rating Star" />
  <img src="./../../../../assets/images/icons/star-unfilled.svg" alt="Filled rating Star" />
  <img src="./../../../../assets/images/icons/star-unfilled.svg" alt="Filled rating Star" />
  <img src="./../../../../assets/images/icons/star-unfilled.svg" alt="Filled rating Star" />
  <img src="./../../../../assets/images/icons/star-unfilled.svg" alt="Filled rating Star" />
</div>
